var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('v-main',{staticClass:"mt-5"},[_c('v-container',[_c('PlasmicRootProvider',{attrs:{"loader":this.loader}},[_c('Authenticator',[_c('router-view')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }